import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// Fade out the branded launch splash once the app has mounted
(function hideSplash() {
  const remove = () => {
    const s = document.getElementById('splash');
    if (!s) return;
    s.classList.add('hide');
    setTimeout(() => s.remove(), 600);
  };
  setTimeout(remove, 900);
})();
